@if (!editMode) {
  <h2 mat-dialog-title>Modul Webcam / Bild hinzufügen</h2>
}
@if (editMode) {
  <h2 mat-dialog-title>Modul Webcam / Bild editieren</h2>
}
<mat-dialog-content>
  <!-- <pre>Form values: {{ webcamForm?.value | json }}</pre> -->
  <div>
    <form
      [formGroup]="webcamForm"
      (ngSubmit)="updateOrCreateModule()"
      ngNativeValidate
      class="d-flex flex-column"
      >
      <mat-form-field>
        <mat-label>Überschrift</mat-label>
        <input matInput formControlName="headline" required />
        @if (webcamForm.controls.headline.hasError('required')) {
          <mat-error
            >Überschrift angeben</mat-error
            >
          }
        </mat-form-field>

        <!-- <mat-form-field>
        <mat-label>Bildbeschreibung</mat-label>
        <input matInput formControlName="imageCaption" />
      </mat-form-field> -->

      <mat-label class="mb-3 mt-2">Verfügbare Stationen</mat-label>
      <mat-radio-group formControlName="location" class="flex flex-col mb-6">
        @for (loc of availableLocations; track loc) {
          <mat-radio-button
            class="mb-4"
            [value]="loc.id"
            >
            <p class="mb-1 p-0 leading-none text-lg">{{ loc.name }}</p>
            <p class="m-0 p-0 leading-none text-gray-600">
              {{ loc.auftraggeber }}
            </p>
          </mat-radio-button>
        }
      </mat-radio-group>
      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="!webcamForm.valid || submitting"
        >
        @if (editMode) {
          Speichern
        }
        @if (!editMode) {
          Hinzufügen
        }
      </button>
    </form>
  </div>
</mat-dialog-content>
